import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { createPortal } from "react-dom";
import { currentDomain, currentPath } from "../Index";
import { usePromotionsData } from "../data/PromotionData";
import { useNavigate } from "react-router-dom";
import useAppPromotionTheme from "../hooks/useAppPromotionTheme";
import MasterGamesList from "../data/MasterGamesList";
import RiseOfHeroesGame from "../snippets/games/RiseOfHeroesGame";
import ScrollLoader from "../snippets/games/ScrollLoader";
import { useSchedule } from "../data/ScheduleContext";

export default function RiesOfHeroes({ isLightMode }) {
	const isAppPromo = useAppPromotionTheme(isLightMode);
	const { promotionsData } = usePromotionsData();
	const data = promotionsData.find((promo) => promo.title === "Rise Of Heroes");
	const [isMobile, setIsMobile] = useState(false);
	const [isLoggedIn, setIsLoggedIn] = useState(false);
	const [loading, setLoading] = useState(true);
	const [showGame, setShowGame] = useState(false);
	const { isVisible } = useSchedule();

	const navigate = useNavigate();

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth < 841);
		};
		handleResize();
		window.addEventListener("resize", handleResize);
		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);

	useEffect(() => {
		const loggedInState = localStorage.getItem("isLoggedIn") === "true";
		setIsLoggedIn(loggedInState);
	}, []);

	useEffect(() => {
		if (!data) {
			navigate("/not-found");
		}
	}, [data, navigate]);

	if (!data) return null;

	const handleShowGame = () => {
		setLoading(true);
		setShowGame(true);

		setTimeout(() => {
			setLoading(false);
		}, 3000);
	};

	return (
		<>
			<Helmet>
				<meta charSet="utf-8" />
				<title>Rise of Heroes: Flame of Victory</title>
				<link rel="icon" href="/images/fav.webp" sizes="32x32" />
				<meta name="description" content="ddd" />
				<link rel="canonical" href={`${currentDomain}${currentPath}`} />
			</Helmet>
			<div className="promotion-page-main all-page-main-container-min-height">
				<div className="promotion-page-container main-container-global-adjusted-padding">
					<div className="promotion-tnc-page">
						<div className="promotion-page-breadcrumb">
							<a
								href={
									isAppPromo
										? "/promotion/".replace("/promotion", "/app-promotion")
										: "/promotion/"
								}
							>
								Promotions
							</a>
							/ <span>{data.title}</span>
						</div>
						<div className="promotion-tnc-banner">
							<img
								src={isMobile ? data.imgSrc : data.bannerSrc}
								alt={`FGH${data.title}`}
							/>
							<div className="promotion-tnc-content">
								<div className="promotion-tnc-info">
									<div
										className={`promotion-indication-message ${data.promotionMessage.class}`}
									>
										{data.promotionMessage.text}
									</div>
									<h1>Rise of Heroes: Flame of Victory</h1>
									<h2>Ignite the flame. Claim your victory</h2>
									<div className="promotion-tnc-period">
										<strong> Event Period: </strong>
										<span> August 3 - August 31, 2026 </span>
									</div>
								</div>
								<div className="promotion-tnc-mechanic-content">
									{isLoggedIn && !isAppPromo && (
										<div className="promotion-tnc-btn-wrapper">
											{isVisible ? (
												<button
													className="promotion-cta-btn"
													onClick={handleShowGame}
												>
													View Game
												</button>
											) : null}
										</div>
									)}
									<strong>Promo Mechanics</strong>
									<ol>
										<li>
											Answer the call of victory by playing any Fachai slots on
											the FGH website.
										</li>
										<li>
											Reach a minimum of 5,000 total weekly turnover to rise
											through the ranks and enter the Leaderboard, from Monday
											12:00 PM to the following Monday 11:59 AM.
										</li>
										<li>
											The Top 25 heroes with the highest turnover at the end of
											each weekly cut-off will earn their place in the Flames of
											Fate Challenge.
										</li>
										<li>
											Flames of Fate Challenge (Bonus Game)
											<ul style={{ marginBottom: "0" }}>
												<li>
													Qualified heroes will face three (3) Flames of Fate -
													every Monday from 12nn - 3pm.
												</li>
												<li>Choose one flame to unlock your reward.</li>
												<li>
													Prizes include a random number of Free Spins, granted
													by fate.
												</li>
											</ul>
										</li>
										<li>
											Awarding of Prizes:
											<ul style={{ marginBottom: "0" }}>
												<li>
													Free Spins will be credited to the winners’ accounts,
													provided that they have already selected their flame.
												</li>
												<li>
													If a winner has not selected from the three Flames of
													Fate by Monday at 3PM, the system will automatically
													select the prize, which will be credited to their
													account accordingly.
												</li>
											</ul>
										</li>
										<li>
											Hero’s Advantage : All rewards come with NO rollover
											requirement - your victory is yours to keep.
										</li>
										<li>
											FGH reserves the right to amend, extend, or terminate this
											promotion at any time without prior notice.
										</li>
										{isAppPromo && (
											<p style={{ color: "red", fontStyle: "italic" }}>
												** This game can only be played on the website. **
											</p>
										)}
										{!isAppPromo && <li>Free Spins can be used on:</li>}
									</ol>

									{!isAppPromo && <strong> Qualified Games </strong>}
									{!isAppPromo && (
										<MasterGamesList
											qualifiedGamesOnly="on"
											customAdvantGames="gameListWrapper promotion-signup-game-list"
											customQualifiedGames={[
												{
													provider: "fachai",
													gameName: "JUNGLE BANG BANG",
												},
												{
													provider: "fachai",
													gameName: "CHINESE NEW YEAR MOREWAYS",
												},
												{
													provider: "fachai",
													gameName: "Chinese New Year 2",
												},
											]}
											rank="off"
											limit={3}
											headerText={null}
											linkTo={null}
											headerTag="h2"
										/>
									)}

									{!isAppPromo && (
										<div className="promotion-tnc-cta">
											<a
												className="promotion-cta-btn"
												href="/slots/?provider=FACHAI"
											>
												PLAY NOW
											</a>
										</div>
									)}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			{showGame &&
				createPortal(
					loading ? (
						<ScrollLoader />
					) : (
						<RiseOfHeroesGame onClose={() => setShowGame(false)} />
					),
					document.body,
				)}
		</>
	);
}
